<template>
	<div class="social">
		<icon @click.prevent="shareToMobile" icon="arrows/share/share-top-right" v-if="mobile"></icon>
		<icon @click.prevent="shareToFacebook" icon="social/platforms/facebook" v-if="!mobile" class="fill"></icon>
		<icon @click.prevent="shareToTwitter" icon="social/platforms/twitter" v-if="!mobile" class="fill"></icon>
	</div>
</template>

<script>
	export default {
		props: ['url', 'title', 'text'],
		computed: {
			mobile() {
				return this.$store.state.mobile;
			}
		},
		methods: {
			async shareToMobile() {
				if(typeof(navigator.share) === 'undefined') {
					return;
				}
				try {
					await navigator.share({
						url: window.location.href,
						title: this.title,
						text: this.text
					});
				} catch(e) {}
			},
			shareToTwitter() {
				window.open('http://www.twitter.com/share?url=' + this.url, '_blank');
			},
			shareToFacebook() {
  				window.open('https://www.facebook.com/sharer/sharer.php?u=' + this.url , '_blank');
			}
		}
	}
</script>